/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamGridExamidQueryResponse,
  GetApiV1ExamGridExamidPathParams,
  GetApiV1ExamGridExamid400,
  GetApiV1ExamGridExamid401,
  GetApiV1ExamGridExamid500,
} from "../../types/examEvaluationController/GetApiV1ExamGridExamid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamGridExamid } from "../../clients/examEvaluationController/getApiV1ExamGridExamid.ts";

export const getApiV1ExamGridExamidQueryKey = (
  examId: GetApiV1ExamGridExamidPathParams["examId"],
) =>
  [{ url: "/api/v1/exam/grid/:examId", params: { examId: examId } }] as const;

export type GetApiV1ExamGridExamidQueryKey = ReturnType<
  typeof getApiV1ExamGridExamidQueryKey
>;

export function getApiV1ExamGridExamidQueryOptions(
  examId: GetApiV1ExamGridExamidPathParams["examId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamGridExamidQueryKey(examId);
  return queryOptions<
    GetApiV1ExamGridExamidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamGridExamid400
      | GetApiV1ExamGridExamid401
      | GetApiV1ExamGridExamid500
    >,
    GetApiV1ExamGridExamidQueryResponse,
    typeof queryKey
  >({
    enabled: !!examId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamGridExamid(examId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a prova para exibição por id. **(Requer Authorization para autenticação)**
 * @summary Buscar prova por id (Requer Authorization para autenticação)
 * {@link /api/v1/exam/grid/:examId}
 */
export function useGetApiV1ExamGridExamid<
  TData = GetApiV1ExamGridExamidQueryResponse,
  TQueryData = GetApiV1ExamGridExamidQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamGridExamidQueryKey,
>(
  examId: GetApiV1ExamGridExamidPathParams["examId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamGridExamidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamGridExamid400
          | GetApiV1ExamGridExamid401
          | GetApiV1ExamGridExamid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamGridExamidQueryKey(examId);

  const query = useQuery(
    {
      ...getApiV1ExamGridExamidQueryOptions(examId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamGridExamid400
      | GetApiV1ExamGridExamid401
      | GetApiV1ExamGridExamid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
